module.exports = __webpack_public_path__ + "static/Developers-00f5181e297ed35911a728e1b85005e2.svg";